const gamesFa = {
  gameCryptoWar: "جنگ کریپتوها",
  gameSoccer: "فوتبال",
  soccer: "فوتبال",
  cryptoWars: "کریپتو وارز",
};

export default gamesFa;
